import { formatMessage } from '../../utils/formatMessage';

const SALES_FORMAT_LABELS = {
  offline: 'Офлайн',
  online: 'Онлайн',
  both: 'Офлайн + онлайн',
};

const DECISION_SPEED_LABELS = {
  fast: 'Быстро (до 1 дня)',
  medium: 'Средне (2–7 дней)',
  long: 'Долго (недели+)',
};

const SEGMENT_COPY = {
  PAIN_PRICE: 'Переплата и непрозрачная цена за {product}',
  PAIN_COMPARE: 'Сложно сравнить {product} с {competitors}',
  PAIN_RISK: 'Страх ошибиться и потерять деньги/время',
  PAIN_TIME: 'Нет времени разбираться — нужно {problem} срочно',
  PAIN_STRESS: 'Стресс от нерешённой задачи: {problem}',
  PAIN_UNCERTAIN: 'Неясно, кто в {city} реально поможет',
  PAIN_LOW_QUALITY: 'Опыт плохого сервиса у {competitors}',
  PAIN_STATUS: 'Важно не ошибиться публично при выборе {product}',
  PAIN_SERVICE: 'Нет персонального подхода у массовых игроков',
  GAIN_SAVE: 'Сэкономить без потери качества',
  GAIN_PREDICT: 'Предсказуемый результат по {product}',
  GAIN_QUALITY: 'Уверенность в качестве и гарантиях',
  GAIN_FAST: 'Быстро закрыть задачу: {problem}',
  GAIN_PEACE: 'Спокойствие — проблема решена',
  GAIN_RESULT: 'Конкретный измеримый результат',
  GAIN_STATUS: 'Статус и уверенность в выборе',
  GAIN_SERVICE: 'Внимательный сервис и сопровождение',
  GAIN_EXPERT: 'Экспертиза по {product}',
  OBJ_PRICE: '«Дорого» — не видят ценность {product}',
  OBJ_TRUST: '«Не уверен в вас» — мало отзывов/кейсов',
  OBJ_TIMING: '«Подумаю позже» — нет срочности',
  OBJ_SPEED: '«Слишком долго» — ждут быстрее',
  OBJ_QUALITY: '«А вдруг не получится?»',
  OBJ_AVAIL: '«Нет удобного времени/формата»',
  OBJ_WORTH: '«Не вижу разницы с {competitors}»',
  OBJ_DIFF: '«Зачем платить больше?»',
  OBJ_EXPERIENCE: '«Уже пробовал похожее — не сработало»',
  CHURN_PRIMARY_1: 'Не получил обещанный результат по {problem}',
  CHURN_PRIMARY_2: 'Долгое ожидание / плохая коммуникация',
  CHURN_SECONDARY_1: 'Нашёл дешевле у {competitors}',
  CHURN_SECONDARY_2: 'Задача {problem} больше не актуальна',
};
export const NICHE_OPTIONS = [
  { id: 'local_service', label: 'Локальный сервис' },
  { id: 'online_services', label: 'Онлайн-услуги' },
  { id: 'retail_showroom', label: 'Розничный магазин / шоурум' },
  { id: 'ecommerce', label: 'Интернет-магазин' },
  { id: 'b2b_services', label: 'B2B услуги' },
  { id: 'production', label: 'Производство / продукт' },
  { id: 'education', label: 'Образование и экспертный контент' },
  { id: 'real_estate', label: 'Недвижимость и строительство' },
];

export const SALES_FORMAT_OPTIONS = [
  { id: 'offline', label: 'Офлайн' },
  { id: 'online', label: 'Онлайн' },
  { id: 'both', label: 'Офлайн + онлайн' },
];

export const DECISION_SPEED_OPTIONS = [
  { id: 'fast', label: 'Быстро (до 1 дня)' },
  { id: 'medium', label: 'Средне (2–7 дней)' },
  { id: 'long', label: 'Долго (недели+)' },
];

export const DEFAULT_AUDIENCE_INPUTS = {
  businessName: '',
  niche: 'local_service',
  product: '',
  avgPrice: '',
  city: '',
  whoBuys: '',
  problemSolved: '',
  competitors: '',
  salesFormat: 'both',
  decisionSpeed: 'medium',
};

const trim = (v) => (typeof v === 'string' ? v.trim() : '');

const nicheJobs = {
  local_service: [
    'Быстро решить бытовую/личную задачу рядом с домом или работой',
    'Найти надёжного исполнителя без риска и переплаты',
    'Получить понятный результат с гарантией и сервисом',
  ],
  online_services: [
    'Получить экспертную помощь без поездок и ожидания',
    'Доверить задачу специалисту и сэкономить время',
    'Решить вопрос конфиденциально и в удобном формате',
  ],
  retail_showroom: [
    'Увидеть товар вживую перед покупкой',
    'Подобрать вариант под бюджет и задачу',
    'Купить сразу, без долгого ожидания доставки',
  ],
  ecommerce: [
    'Быстро найти и заказать нужный товар с доставкой',
    'Сравнить цены и отзывы без похода по магазинам',
    'Получить выгодное предложение и удобную оплату',
  ],
  b2b_services: [
    'Закрыть бизнес-задачу с предсказуемым результатом',
    'Снизить риски и передать ответственность подрядчику',
    'Масштабировать процесс без найма в штат',
  ],
  production: [
    'Получить стабильного поставщика с нужным качеством',
    'Закупить партию по выгодной цене и в срок',
    'Снизить себестоимость без потери качества',
  ],
  education: [
    'Получить новый навык или результат обучения',
    'Инвестировать в развитие себя или ребёнка',
    'Выбрать программу с понятным итогом и поддержкой',
  ],
  real_estate: [
    'Найти жильё/объект под критерии и бюджет',
    'Провести сделку безопасно и без скрытых рисков',
    'Получить ремонт или стройку в срок и по договору',
  ],
};

const nicheChannels = {
  local_service: ['Яндекс / 2GIS', 'Instagram / Meta', 'Сарафанное радио', 'Google Maps'],
  online_services: ['Instagram', 'Telegram', 'YouTube', 'Контекст Google', 'Рекомендации'],
  retail_showroom: ['Instagram', 'Яндекс / 2GIS', 'Маркетплейсы', 'Наружная реклама рядом'],
  ecommerce: ['Kaspi / маркетплейсы', 'Meta Ads', 'Google Shopping', 'Блогеры', 'Ретаргет'],
  b2b_services: ['LinkedIn', 'Холодные продажи', 'Нетворкинг', 'Контекст', 'Отраслевые мероприятия'],
  production: ['B2B-порталы', 'Прямые продажи', 'Выставки', 'Холодный обзвон', 'Партнёрские сети'],
  education: ['Instagram / Reels', 'YouTube', 'Telegram', 'Вебинары', 'Школьные/родительские чаты'],
  real_estate: ['Instagram', 'Циан / Krisha', 'Яндекс', 'Агентские сети', 'Наружка в районе'],
};

const segmentTemplates = [
  {
    id: 'rational',
    title: 'Рациональный покупатель',
    desc: '{who}, который сравнивает {product} с {competitors} и ищет лучшее соотношение цены и результата',
    painKeys: ['PAIN_PRICE', 'PAIN_COMPARE', 'PAIN_RISK'],
    gainKeys: ['GAIN_SAVE', 'GAIN_PREDICT', 'GAIN_QUALITY'],
    objectionKeys: ['OBJ_PRICE', 'OBJ_TRUST', 'OBJ_TIMING'],
  },
  {
    id: 'urgent',
    title: 'Срочный запрос',
    desc: '{who} с острой потребностью: {problem} — нужно решить быстро в {city}',
    painKeys: ['PAIN_TIME', 'PAIN_STRESS', 'PAIN_UNCERTAIN'],
    gainKeys: ['GAIN_FAST', 'GAIN_PEACE', 'GAIN_RESULT'],
    objectionKeys: ['OBJ_SPEED', 'OBJ_QUALITY', 'OBJ_AVAIL'],
  },
  {
    id: 'premium',
    title: 'За качество и сервис',
    desc: '{who}, для кого важны экспертиза, сервис и статус при выборе {product}',
    painKeys: ['PAIN_LOW_QUALITY', 'PAIN_STATUS', 'PAIN_SERVICE'],
    gainKeys: ['GAIN_STATUS', 'GAIN_SERVICE', 'GAIN_EXPERT'],
    objectionKeys: ['OBJ_WORTH', 'OBJ_DIFF', 'OBJ_EXPERIENCE'],
  },
];

export const validateAudienceInputs = (inputs) => {
  const errors = {};
  if (!trim(inputs.product)) errors.product = 'Укажите продукт или услугу';
  if (!trim(inputs.whoBuys)) errors.whoBuys = 'Опишите, кто ваш клиент';
  if (!trim(inputs.problemSolved)) errors.problemSolved = 'Опишите задачу клиента';
  return errors;
};

export const generateJTBDProfile = (inputs) => {
  const product = trim(inputs.product) || 'ваш продукт/услуга';
  const who = trim(inputs.whoBuys) || 'ваш клиент';
  const problem = trim(inputs.problemSolved) || 'свою задачу';
  const city = trim(inputs.city) || 'вашем городе';
  const competitors = trim(inputs.competitors) || 'аналоги на рынке';
  const price = trim(inputs.avgPrice);
  const niche = NICHE_OPTIONS.find((n) => n.id === inputs.niche)?.id || 'local_service';
  const vars = { product, who, problem, city, competitors };
  const personalize = (template) => formatMessage(template, vars);
  const segmentLine = (key) => personalize(SEGMENT_COPY[key] || key);

  const jobs = (nicheJobs[niche] || nicheJobs.local_service).map(
    (job) => `«${job}» — в контексте ${product}`,
  );

  const channels = (nicheChannels[niche] || [])
    .map((ch) =>
      inputs.salesFormat === 'offline' && ch.includes('Kaspi') ? null : `${ch} — для аудитории в ${city}`,
    )
    .filter(Boolean);

  if (inputs.salesFormat === 'online' && !channels.some((c) => c.includes('сайт') || c.includes('site'))) {
    channels.push(`Сайт / лендинг с заявкой на ${product}`);
  }

  const selectionFactors = [
    `Цена и соотношение цена/качество (${price || 'цена не указана'})`,
    `Доверие: отзывы, кейсы, репутация в ${city}`,
    `Удобство формата: ${SALES_FORMAT_LABELS[inputs.salesFormat] || inputs.salesFormat}`,
    `Скорость результата (${DECISION_SPEED_LABELS[inputs.decisionSpeed] || inputs.decisionSpeed})`,
    'Социальное доказательство и рекомендации',
  ];

  const segments = segmentTemplates.map((tpl, idx) => ({
    id: tpl.id,
    title: tpl.title,
    description: personalize(tpl.desc),
    jobs: [jobs[idx % jobs.length], jobs[(idx + 1) % jobs.length]],
    pains: tpl.painKeys.map(segmentLine),
    gains: tpl.gainKeys.map(segmentLine),
    objections: tpl.objectionKeys.map(segmentLine),
    churnPrimary: [segmentLine('CHURN_PRIMARY_1'), segmentLine('CHURN_PRIMARY_2')],
    churnSecondary: [segmentLine('CHURN_SECONDARY_1'), segmentLine('CHURN_SECONDARY_2')],
  }));

  const priorities = [
    `Протестировать оффер на сегменте «${segments[0].title}»`,
    `Усилить сообщение вокруг задачи: ${problem}`,
    `Отстроиться от ${competitors} в ${city} через кейсы и отзывы`,
  ];

  const conclusions = [
    `Ядро аудитории — ${who}, покупающий ${product}`,
    `Главная «работа» клиента — ${problem}`,
    `Ключевой риск — уход к ${competitors} без сильного доверия`,
  ];

  return {
    segments,
    jobs,
    channels: [...new Set(channels)].slice(0, 6),
    selectionFactors,
    priorities,
    conclusions,
    meta: { product, who, problem, city, niche },
  };
};

export const HOW_STEPS = [
  {
    num: '1',
    title: 'Каждый пункт имеет вес.',
    text: '«Да» = 100% балла, «Частично» = 50%, «Нет» = 0%. Итог — сумма взвешенных баллов.',
  },
  {
    num: '2',
    title: 'Пороги готовности:',
    text: 'до 50% — рано, 50–79% — доработать, 80%+ — можно запускать тест.',
  },
];
